import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { DynamicRoles, MenuItem } from '../interfaces/base-core-services.interface';
import { UserInfoService } from '../services/user-info.service';
import { EnvironmentService } from './environment.service';
import { HttpErrorHandlerService, MessageType } from './http-error-handling.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  menu: MenuItem[]=[] ;
  mainMenu!: MenuItem;
  subMenu: MenuItem[]  ;
  private menu$ = new Subject<any>();

  constructor(public http: HttpClient,
    private env: EnvironmentService,
    private storage: StorageService,
    private router: Router,
    private userInfoService: UserInfoService,
    private httpMessage: HttpErrorHandlerService) { }

  menuLoadedWith = '';
  menuLoaded$(loadedWith: string) {
    this.menuLoadedWith = loadedWith;
    return this.menu$.asObservable();
  }

  addDashboardSubMenus(): void {
    const dashboardList = this.userInfoService.getDashboardList().dashboardList;
    const subMenus: MenuItem[]=[];
    if (dashboardList && dashboardList.length) {
      // for (const item of dashboardList) {
      //   subMenus.push(
      //     {
      //       'label': item.name,
      //       'link': '/home',
      //       'dashboardId': item.id,
      //       'operationName': 'home',
      //       'icon': 'appstore',
      //       'filters': item.filters,
      //       'selected': false,
      //       'C'
      //       'hide': false
      //     }
      //   );
      // }
    }
    const index = this.menu.findIndex(menu => menu.operationName === 'dashboard');
    if (index > -1)
      this.menu[index].children?.push(...subMenus);
  }

  getMenu(): Observable<MenuItem[]> {
    return this.http.get<MenuItem[]>(this.env.getEnvironment().assetsEndPoint + '/assets/menu/app-menu.json')
  }

  fetchMenus() {
    this.getMenu().subscribe((res: MenuItem[]) => {
      console.log(res)
      this.isOpenMenuFlag(res);
      this.menu = res;
      let menu_roles:any = [];
      const appRoles = JSON.parse(this.storage.getSessionStorageItem(StorageService.CONST.CUSTOM_ROLE));
      appRoles.forEach((element:any) => {
        const data: any = _.find(this.menu, (el: MenuItem) => {
          if (element.operationName && el.operationName && el.operationName.toLowerCase() == element.operationName.toLowerCase()) return el
          else return null
        });
        if (data && data['operationName'] == 'dashboard') {
          menu_roles.unshift(data)
        } else {
          if (data && data.children && data.children.length > 0) {
            data.children.forEach((child:any) => {
              const index = element.operationList.findIndex((itm:any) => child.operationName && (itm.subList.toLowerCase() == child.operationName.toLowerCase()));
              if (index < 0) {
                child.hide = true;
              } else {
                child.hide = false;
              }
            });
          }
          menu_roles.push(data)
        }
      });
      menu_roles = _.without(menu_roles, undefined);
      this.menu = menu_roles;
      this.addDashboardSubMenus();
      // TODO, below case the screen to redirect which is impacting isDialog
      // if(this.menu.length>0) this.onMainMenu(this.menu[0]);

      const menuOrder = this.env.getEnvironment().menuOrder;
      this.menu = _.sortBy(this.menu, (item) => {
        return menuOrder.indexOf(item.operationName) != -1 ? menuOrder.indexOf(item.operationName) : menuOrder.length;
      });
      this.addGsfSubMenu();
      this.menu$.next(this.menuLoadedWith);
    });
  }

  addGsfSubMenu() {
    const userInfo = this.userInfoService.getUserInfo();
    if(userInfo) {
      const dynamicRoles:any = userInfo.dynamicRoles;
    this.menu.forEach((m: MenuItem) => {
      dynamicRoles.forEach((dr: DynamicRoles) => {
        if (dr.serviceGroup === m.operationName) {
          m.children?.push({
            label: dr.label ? dr.label : 'GSF ' + dr.serviceName,
            link: '/gsf/list/' + dr.serviceName,
            icon: dr.icon ? dr.icon : 'employee',
            hide: false,
            selected: false,
            children: []
          });
        }
      });
    });
    }    
  }

  isOpenMenuFlag(menuItem: MenuItem[]) {
    menuItem.forEach((item) => {
      item['open'] = false;
      if (item.children && item.children.length > 0) {
        this.isOpenMenuFlag(item.children);
      }
    });
  }

  openMenuHandler(clickedMenuItem:any, menuType:any) {
    console.log('openMenuHandler');
    if (menuType === 'mainmenu') {
      this.menu.forEach((item) => {
        if (clickedMenuItem.link !== item.link) {
          item.open = false;
        }
      });
    }
  }

  setMainMenu(menuItem: MenuItem) {
    this.mainMenu = menuItem;
    if (this.mainMenu.children && this.mainMenu.children.length > 0) {
      this.subMenu = this.mainMenu.children;
    }
  }
  getMainMenu(): MenuItem[] {
    return _.isEmpty(this.menu) ? [] : this.menu;
  }

  getSubMenu(): MenuItem[] {
    return _.isEmpty(this.subMenu) ? [] : this.subMenu;
  }

  onMainMenu(mainMenu: MenuItem | any) {
    const custId = this.userInfoService.getUserCustomerId();
    const appRoles = JSON.parse(this.storage.getSessionStorageItem(StorageService.CONST.CUSTOM_ROLE));
    this.mainMenu = mainMenu;
    this.subMenu = mainMenu.children;
    const data = _.find(appRoles, (el) => {
      if (el.operationName.toLowerCase() == this.mainMenu.operationName?.toLowerCase()) return el
    })
    this.mainMenu.children?.forEach(el => {
      if (custId && el.label === 'menu.new-registration') el.label = 'menu.view-registration';
      if (_.has(el, 'operationName')) {
        const index = data.operationList.findIndex((itm:any) => itm.subList.toLowerCase() == el.operationName?.toLowerCase());
        if (index < 0) {
          el.hide = true;
        } else {
          el.hide = false;
        }
      }
    })
    this.router.navigateByUrl(this.getLink(this.mainMenu));
  }

  getLink(menu: MenuItem) : any{
    menu.selected = true;
    return menu.link + (
      (menu.children !== undefined && menu.children.length > 0)
        ? this.getLink(menu.children[_.findIndex(menu.children, { hide: false })])
        : ''
    );
  }

  onSubMenu(subMenu: MenuItem) {
    if (subMenu.dashboardId) {
      setTimeout(() => {
        this.router.navigate([this.mainMenu.link + subMenu.link, subMenu.dashboardId]);
      }, 0);
    } else {
      setTimeout(() => {
        this.router.navigate([this.mainMenu.link + subMenu.link]);
      }, 0);
    }
  }

  onChildMenu(subMenu: MenuItem, childMenu: MenuItem) {
    setTimeout(() => {
      this.router.navigateByUrl(this.mainMenu.link + subMenu.link + childMenu.link)
    }, 0);
  }

  goToMenuByUrl(link:any) {
    if (link.indexOf('/app/dashboard') >= 0) {
      this.onMainMenu(_.find(this.menu, { link: '/app/dashboard' }));
    } else if (link.indexOf('/app/landing') >= 0) {
      this.menu.forEach((m) => {
        m.selected = false;
      });
    } else {
      this.applyMenuSelection(link);
      this.router.navigate([link]);
    }

  }

  noAccessMessage = '';
  applyMenuSelection(link: string) {
    if (link.startsWith('/app') && (link !== '/app/landing' && !link.startsWith('/app/settings'))) {
      const mLink = _.cloneDeep(link);
      let linkFound = false;
      this.menu.forEach((item) => {
        if (mLink.includes(item.link)) {
          linkFound = true;
        }
      });
      const userType = this.userInfoService.getUserType();
      if (userType && userType === 'admin_user'
        && link.startsWith('/app/work-list-mgmt/task/admin') && link.endsWith('details')) {
        linkFound = true;
      } else if (userType && userType === 'consumer_user'
        && link.startsWith('/app/work-list-mgmt/task/user') && link.endsWith('details')) {
        linkFound = true;
      }
      if (this.menu.length > 0 && !linkFound) {
        if (this.noAccessMessage !== link) {
          this.httpMessage.showTopFloatMessage('You don\'t have access.', MessageType.ERROR);
          this.noAccessMessage = link;
          setTimeout(() => {
            this.noAccessMessage = '';
          }, 100);
        }

        this.router.navigateByUrl('/app/landing');
      }
    }

    let mLink = link;
    this.menu.forEach((menu) => {
      if (mLink.indexOf(menu.link) >= 0) {
        this.mainMenu = menu;
        menu.selected = true;
        mLink = mLink.replace(menu.link, '');
        if (menu.children && menu.children.length > 0) {
          this.subMenu = menu.children;
          menu.children.forEach((child) => {
            if (mLink.indexOf(child.link) >= 0) {
              if (child.link.length > 0)
                child.selected = true;
              mLink = mLink.replace(child.link, '');
              if (child.children && child.children.length > 0) {
                child.children.forEach((superChild) => {
                  if (mLink.indexOf(superChild.link) >= 0) {
                    if (superChild.link.length > 0) {
                      superChild.selected = true;
                      child.selected = true;
                    } else {
                      superChild.selected = false;
                    }
                  } else {
                    superChild.selected = false;
                  }
                });
              }
            } else {
              child.selected = false;
            }
          });
        } else {
          this.subMenu = [];
        }
      } else {
        menu.selected = false;
      }
    });
  }
}
